module.exports = __webpack_public_path__ + "img/plan0.3566fbbf.png";